import getConfig from 'next/config';
import { HTTPClient } from '../lib/api';

declare global {
  interface Window {
    gapi: any;
  }
}

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

const googleAPIService = async (): Promise<any> => {
  const config = await HTTPClient(`${BASE_URL_MEDIA}api/accounts/google-oauth/`, {});
  let auth2;
  return new Promise((resolve) => {
    window.gapi.load('auth2', function () {
      auth2 = window.gapi.auth2.init({
        client_id: `${config.googleOauth}.apps.googleusercontent.com`,
        scope: 'email profile',
      });
      return resolve(auth2);
    });
  });
};

export default googleAPIService;